import { render } from "./CartBasket.vue?vue&type=template&id=4b5a0f88"
import script from "./CartBasket.vue?vue&type=script&lang=js"
export * from "./CartBasket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__